module.exports = __webpack_public_path__ + "06eda91635927a72bbcf45d6f9acbb02.pdf";